module.exports = __webpack_public_path__ + "img/tool-01.7c1bd4b5.svg";